export default __webpack_public_path__ + "img/hzbcEBaX.82ef8065.svg";